import Pusher from 'pusher-js';
import _ from 'lodash';

const PUSHER_KEY = process.env.PUSHER_KEY;

Pusher.logToConsole = process.env.NODE_ENV === 'development';

// Setting the step
export const setCurrentStep = ({commit}, step) => {
  return commit('SET_CURRENT_STEP', step);
};

export const setNextStep = ({commit}, step) => {
  return commit('SET_NEXT_STEP', step);
};

export const setPreviousStep = ({commit}, step) => {
  return commit('SET_PREVIOUS_STEP', step);
};

// When you go back from review page
export const setNextToReview = ({commit}, value) => {
  return commit('SET_NEXT_TO_REVIEW', value);
};

// Set tracking code, so we can better identify who's filling out the Form
export const setTrackingCode = ({commit}, code) => {
  return commit('SET_TRACKING_CODE', code);
};

// Set short code
export const setShortCode = ({commit}, shortCode) => {
  return commit('SET_SHORT_CODE', shortCode);
};

// Set User Verified Token
export const setToken = ({commit}, token) => {
  return commit('SET_TOKEN', token);
};

export const setError = ({commit}, errObj) => {
  console.error('Error', errObj);
  commit('SET_ERROR', errObj);
};

export const setIsResidentRequirement = ({commit}, value) => {
  return commit('SET_IS_RESIDENT_REQUIREMENT', value);
};

export const setStepsMapWithQuestions = ({commit}, questions) => {
  return commit('SET_STEPS_MAP_WITH_QUESTIONS', questions);
};

export const setStepsMapWithNoQuestions = ({commit}) => {
  return commit('SET_STEPS_MAP_WITH_NO_QUESTIONS');
};

// If we should hide the proxyholder question
export const setStepsSkipProxyHolder = ({commit}) => {
  commit('SET_STEPS_SKIP_STEP', '/proxy');
};

// Should we ask the proxyholder question before other questions
export const setStepsAskFirstProxyHolder = ({commit}) => {
  commit('SET_STEPS_ASK_FIRST_PROXYHOLDER', '/proxy');
};

// If we should hide the comms question
export const setStepsSkipComms = ({commit}) => {
  commit('SET_STEPS_SKIP_STEP', '/comms');
};

export const setAppDisplayOptions = ({commit}, options) => {
  return commit('SET_APP_DISPLAY_OPTIONS', options);
};

export const setMeetingOptions = ({commit}, options) => {
  return commit('SET_MEETING_OPTIONS', options);
};

export const setCustomSignature = ({commit}, signature) => {
  return commit('SET_CUSTOM_SIGNATURE', signature);
};

/**
 * Check if any actions need to be automatically executed on load
 * @param {String} action    - the action to run
 * @param {String} shortCode - the shortCode
 * @param {String} token     - the voter Token
 */
export const runLoadActions = async (
  {dispatch},
  {action, shortCode, token}
) => {
  try {
    switch (action) {
      case 'rsvp':
        // If RSVP, then mark it in API and show the RSVP modal
        await dispatch(
          'voter/markRsvp',
          {shortCode, token, isAttending: true},
          {root: true}
        );
        dispatch('setShowRsvpModal', true);
        break;
      case 'absent':
        // If RSVP, then mark it in API and show the RSVP modal
        await dispatch(
          'voter/markRsvp',
          {shortCode, token, isAttending: false},
          {root: true}
        );
        dispatch('setShowRsvpModal', true);
        break;
      case 'revoke':
        dispatch('setShowRevokeModal', true);
        break;
      default:
        return null;
    }
  } catch (err) {
    // If actions fail for whatever reason, ensure no action modal shows
    dispatch('setShowRsvpModal', false);
  }
};

export const setShowRsvpModal = ({commit}, showModal) => {
  commit('SET_SHOW_RSVP_MODAL', showModal);
};

export const setShowRevokeModal = ({commit}, showModal) => {
  commit('SET_SHOW_REVOKE_MODAL', showModal);
};

export const setblockUnverifiedVoting = ({commit}, value) => {
  commit('SET_BLOCK_UNVERIFIED_VOTING', value);
};

export const setPreviewMode = ({commit}, value) => {
  commit('SET_PREVIEW_MODE', value);
};

export const initPusher = ({state, commit, dispatch}, shortCode) => {
  try {
    const pusher = new Pusher(PUSHER_KEY, {
      cluster: 'us2'
    });

    // Save to store, so we can force disconnect
    commit('SET_PUSHER', pusher);

    // Subscribe to main pusher channel for Dashboard events for this meeting
    const channel = state.pusher.subscribe(`dash-${shortCode}`);

    // Define all events and subscriptions to listen for here.

    // For event to pop up a chat beacon message
    channel.bind('proxy-update', async data => {
      const {refresh} = data;

      if (/confirm/.test(window.location.href)) {
        await dispatch('confirm/getProxyContent', {root: true});
      }

      if (refresh) {
        return (window.location.href = '/?mode=preview');
      }

      return dispatch(
        'meeting/initializeMeeting',
        {shortCode, trackingCode: '', token: '', mode: 'preview'},
        {root: true}
      );
    });
  } catch (err) {
    console.error('Error: initPusher', err);
    throw err;
  }
};

export const destroyPusher = ({state, commit}) => {
  if (!_.isEmpty(state.pusher)) {
    return commit('CLEAR_PUSHER');
  }
};
